var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{class:{ 'font-weight-bold': _vm.isFontBold },attrs:{"text":!!_vm.text,"color":_vm.color},on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.getText))]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }